import { WorkspaceTab } from '@sales-app/context/workspace/workspace.type'
import React, { FC } from 'react'

import { ErrorBoundary } from '@/components'

import { SearchMap } from './SearchMap/SearchMapWithContext'

type Props = {
  allowMapInteractions: boolean
  bookablePerson: WorkspaceTab
}

export const MapView: FC<Props> = (props) => {
  return (
    <div className="flex flex-col bg-white" id="search-map-wrapper">
      <ErrorBoundary>
        <SearchMap {...props} />
      </ErrorBoundary>
    </div>
  )
}
